import { useTranslations } from '@vocab/react';

import { ColumnCard } from 'src/components/Card/ColumnCard';
import { LoadingItem } from 'src/components/LoadingBlock/LoadingBlock';
import {
  PROFILE_VISIBILITY,
  PROFILE_VISIBILITY_V2,
} from 'src/components/Router';
import { useMode } from 'src/components/Router/useMode';
import { useNavigateRoute } from 'src/components/Router/useNavigateRoute';
import { EDIT } from 'src/consts';

import { EditProfileVisibility } from '../EditProfileVisibility/EditProfileVisibilityContainer';

import translations from './.vocab';
import { ProfileVisibilityStatus } from './ReadProfileVisibilityStatus';

interface Props {
  loading?: boolean;
  personalDetailsLoading: boolean;
}

export const ReadProfileVisibility = ({
  loading,
  personalDetailsLoading,
}: Props) => {
  const { t } = useTranslations(translations);

  const navigate = useNavigateRoute();

  // Check mode for both profile-visibility and profile-visibility-v2 cards
  const mode = useMode(PROFILE_VISIBILITY);
  const modeLegacy = useMode(PROFILE_VISIBILITY_V2);
  const isDrawerOpen = mode === EDIT || modeLegacy === EDIT;

  const handleProfileVisibilityEditClicked = () => {
    navigate({
      card: PROFILE_VISIBILITY,
      mode: EDIT,
    });
  };

  const cardButtonProps = {
    onClick: handleProfileVisibilityEditClicked,
    label: t('Edit visibility'),
  };

  return (
    <>
      <ColumnCard
        name={PROFILE_VISIBILITY}
        title={t('Profile visibility')}
        loader={<LoadingItem type="text" size="standard" width="large" />}
        loading={loading}
        buttonProps={cardButtonProps}
      >
        <ProfileVisibilityStatus loading={loading} />
      </ColumnCard>
      <EditProfileVisibility
        isOpen={isDrawerOpen}
        personalDetailsLoading={personalDetailsLoading}
      />
    </>
  );
};
